import React from "react";
import classNames from "classnames";
import { ListItemTextProps } from "./PropsType";

export default function ListItemText(props: ListItemTextProps) {
  const { children, className, prefixCls = "bm-List-item-text" } = props;
  const styleClass = classNames(prefixCls, className);
  return <div className={styleClass}>{children}</div>;
}
